var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"eicon",attrs:{"aria-hidden":"true","font-size":_vm.size,"color":_vm.color},on:{"click":_vm.click}},[_c('use',{attrs:{"xlink:href":'#icon-'+_vm.type}})])}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/icon/eicon.vue